import "../../common/common_styles.css";
import { 
  selectSampleWorkInstructionsShown, 
  setSampleWorkInstructionsShown,
  selectSampleWorkData, 
  replaceSampleWorkData,
  setSampleWorkData,
  selectNumSamples, 
  setNumSamples} from '../../slices/gradingForm';
import { useSelector, useDispatch } from "react-redux";
import classes from './SampleWorkCriteria.module.css';
import UploadSampleWorkContent from "../UI/UploadContent/uploadSampleWorkContent";
import Modal from "../../common/InfoModal";
import { useLocation } from "react-router-dom";
import ErrorModal from "../UI/error_modal/error_modal";
import { useState, useEffect } from "react";
import util from "../../styles/utilities.module.css";

const SampleWorkCriteria = ()=>{
    const [fileUploadMessage, setFileUploadMessage] = useState("");
    const [showErrorModal, setShowErrorModal] = useState(false);

    const location = useLocation();

    // Function to check and set the file upload message based on metadata
    const checkFileUploadMessage = (metadata) => {
        let message = "";
        metadata.forEach((file) => {
          // Check if OCR confidence is below a threshold (e.g., 80)
          if (file.ocr_confidence < 80) {
            message += `${file.name} - difficult to read and may need to be rescanned.\n\n`;
          }
        });
        setFileUploadMessage(message);
      };
    
      // Use effect to check and set the message when metadata changes
      useEffect(() => {
        const fileMetadata = location.state?.fileMetadata || [];
        if (fileMetadata.length > 0) {
            checkFileUploadMessage(fileMetadata);
        }
    }, [location.state?.fileMetadata]);
    
    // Directly use fileUploadMessage state to decide modal visibility
    useEffect(() => {
        if (fileUploadMessage) {
          setShowErrorModal(true);
        }
      }, [fileUploadMessage]);
 
    const dispatch = useDispatch();
    const num_samples = useSelector(selectNumSamples);
    const storeData = useSelector(selectSampleWorkData);
    const nameInStore = "sampleWork";


    const handleAddAnotherSample = ()=>{
        dispatch(setNumSamples( num_samples+1 ));
    }

    const removeIndexDataFromStore = (index) => {
      const newStoreData = { ...storeData };
    
      // Loop from the current index to the end of the array-like structure
      for (let i = index; i < num_samples - 1; i++) {
        newStoreData[nameInStore + "[" + i + "]"] = newStoreData[nameInStore + "[" + (i + 1) + "]"];
        newStoreData[nameInStore + "[" + i + "]_grade"] = newStoreData[nameInStore + "[" + (i + 1) + "]_grade"];
        newStoreData[nameInStore + "[" + i + "]_files"] = newStoreData[nameInStore + "[" + (i + 1) + "]_files"];
        newStoreData[nameInStore + "[" + i + "]_files_qty"] = newStoreData[nameInStore + "[" + (i + 1) + "]_files_qty"];
      }
    
      // Remove the last item since it's now duplicated
      const lastIndex = num_samples - 1;
      delete newStoreData[nameInStore + "[" + lastIndex + "]"];
      delete newStoreData[nameInStore + "[" + lastIndex + "]_grade"];
      delete newStoreData[nameInStore + "[" + lastIndex + "]_files"];
      delete newStoreData[nameInStore + "[" + lastIndex + "]_files_qty"];

      dispatch(replaceSampleWorkData(newStoreData));
      // Update the num_samples in your store as well
      dispatch(setNumSamples(num_samples - 1));
    };

    const numbersArray = Array.from({ length: num_samples });
    const sampleWorkInstructionsShown = useSelector(selectSampleWorkInstructionsShown);
    

    return(
      <>
        {sampleWorkInstructionsShown === false && (
          <Modal>
            <div className={classes.infoModalContainer}>
              <h3>Please submit a few graded samples.</h3>
              <br />
              <p>
                Ideally, provide one sample for each level of your grading scale. This will help the AI understand your grading standards. 
              </p>
              <div style={{ textAlign: "center"}}>
                <button 
                  className={`${util.btn}`} 
                  onClick={() => dispatch(setSampleWorkInstructionsShown(true))}
                  style={{ margin: "20px 0px 0px 0px" }} 
                >
                  Continue
                </button>
              </div>
            </div>
          </Modal>
        )}
  
          <div>
             {numbersArray.map((_,index)=>  
             <UploadSampleWorkContent
              key={index}
              textLabel="Copy/paste or upload sample:"
              textPlaceholder="(Add sample)"
              nameInStore="sampleWork"
              selectStoreData={selectSampleWorkData}
              setStoreData={setSampleWorkData}
              removeIndexDataFromStore={removeIndexDataFromStore}
              index = {index}
              />)}
           
          <br />
          <br />    
            <div style={{display:"flex", justifyContent:"end", margin:"0px 40px 20px 0px"}}>             
              <button onClick={handleAddAnotherSample} className={`${util.btn} ${util['btn-sm']}`} type="button">
                Add another sample
              </button>
            </div> 
            <ErrorModal
                    isOpen={showErrorModal}
                    onClose={() => setShowErrorModal(false)}
                    titleText={"Potential issue with upload"}
                    bodyText={fileUploadMessage}
              />

        </div>
    </>
    )
}


export default SampleWorkCriteria;